import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { TextInput } from 'grommet/components/TextInput';
import { Button } from 'grommet/components/Button';
import AccessibleSelect from '../Components/AccessibleSelect';
import ReactTable from "react-table";
import { RadioButton } from "grommet/components/RadioButton";
import { ERRORMESSAGE } from '../Constants.js';
import data from '../Data.json';
import { Layer } from 'grommet/components/Layer';
import ReactExport from "react-data-export";
import ModalError from '../Components/ModalError';
import { GetTotalSummaryCtrl } from '../Controllers/Transaction/GetTotalSummaryCtrl';
import { GetSummaryListCtrl } from '../Controllers/Transaction/GetSummaryListCtrl';
import { GetSummaryTransactionListCtrl } from '../Controllers/Transaction/GetSummaryTransactionListCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, formatAmount } from '../Utils/Utility';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Riepilogo extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            selectedMonthYear: '',
            data: data,
            search: '',
            minamount: '',
            maxamount: '',
            minamountnet: '',
            maxamountnet: '',
            abi: '',
            msgabi: '',
            numericMonths: [],
            selectedMonthYearLabel: '',
            selectedDay: '',
            selectedMov: '',
            /*selected: "",*/
            trBranchCode: "",
            showresult: false,
            showDetailsTable: false,
            /*value: [],*/
            months: [],
            isLeapYear: false,
            LeapYear: '',
            monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            optionsDay: [],
            disabledSDays: false,
            codesoc: "",
            codpos: sessionStorage.getItem("codSocietario") === '0' ? "" : sessionStorage.getItem("codepos"),
            codepv: sessionStorage.getItem("codSocietario") === '0' ? "" : sessionStorage.getItem("code") ? sessionStorage.getItem("code") : '',
            dataHeader: {},
            dataTable: [],
            dataTableDetails: [],
            showTimeoutModal: false,
            showModalError: false,
            //Check table values
            value: !sessionStorage.getItem("i")
                ? null
                : parseInt(sessionStorage.getItem("i")),
            selected: !sessionStorage.getItem("i")
                ? null
                : parseInt(sessionStorage.getItem("i")),
            pages: 0,
            currentPage: 1,
            isRicerca: false,
            loadingExcel: false
        }
        this.setAmount = this.setAmount.bind(this);
        this.setSelectionYearMonth = this.setSelectionYearMonth.bind(this);
        this.setSelectionDay = this.setSelectionDay.bind(this);
        this.showResult = this.showResult.bind(this);
        this.validForm = this.validForm.bind(this);
        this.setPoint = this.setPoint.bind(this);
        this.showDetailsTable = this.showDetailsTable.bind(this);
        this.hideDetails = this.hideDetails.bind(this);
        this.search = this.search.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.goToPage = this.goToPage.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillMount() {
        this.setDates();
        this.isLeapYear();
    }

    setDates() {
        var date = new Date();
        var months = [];

        var numericMonths = [];
        var monthNames = this.state.monthNames;
        for (var i = 0; i < 13; i++) {
            var calMonth = 1 + date.getMonth()
            var tempMonth = calMonth < 10 ? '0' + calMonth : calMonth
            months.push(monthNames[date.getMonth()] + ' ' + date.getFullYear());
            numericMonths.push(date.getFullYear() + '' + tempMonth);
            date.setMonth(date.getMonth() - 1);
        }
        return this.setState({ months, numericMonths });
    }

    isLeapYear() {
        const year = new Date().getFullYear()
        const isLeap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);

        return isLeap
    }

    setAmount(event) {
        var value = event.target.value !== undefined ? event.target.value : '';
        var regexNumb = /^[0-9]+$/;
        value = regexNumb.test(value) ? value : value.replace(/[^0-9]+/g, "");
        if (event.target.id === 'minamount') {
            this.setState({
                minamount: value
            })
        } else if (event.target.id === 'maxamount') {
            this.setState({
                maxamount: value
            })
        } else if (event.target.id === 'minamountnet') {
            this.setState({
                minamountnet: value
            })
        } else if (event.target.id === 'maxamountnet') {
            this.setState({
                maxamountnet: value
            })
        } else if (event.target.id === 'codpos') {
            this.setState({
                codpos: value
            })
        } else if (event.target.id === 'abi') {
            this.setState({
                abi: value
            })
        }
    }

    setSelectionYearMonth(event) {
        // Estrae il valore dall'oggetto dell'opzione selezionata
        const selectedValue = event.option ? event.option.value : '';
        const selectedIndex = this.state.months.findIndex(month => month === selectedValue);
        var val = selectedIndex >= 0 ? this.state.numericMonths[selectedIndex] : '';
        
        // Popola i giorni in base al mese selezionato
        var days = [];
        var selectedMonthText = selectedValue.split(' ')[0];
        var selectedYear = selectedValue.split(' ')[1];
        var monthIndex = this.state.monthNames.indexOf(selectedMonthText);
        
        if (monthIndex >= 0 && selectedYear) {
            var daysInMonth = new Date(parseInt(selectedYear), monthIndex + 1, 0).getDate();
            for (var i = 1; i <= daysInMonth; i++) {
                days.push(i < 10 ? '0' + i : i.toString());
            }
        }
        
        this.setState({
            selectedMonthYearLabel: selectedValue,
            selectedMonthYear: val,
            optionsDay: days,
            disabledSDays: false
        })
    }

    setSelectionDay(event) {
        // Estrae il valore dall'oggetto dell'opzione selezionata
        const selectedValue = event.option ? event.option.value : '';
        
        this.setState({
            selectedDay: selectedValue
        })
    }

    validForm(event) {
        var abi = this.state.abi
        var number = /^\d+$/;

        if (event.target.id === 'abi') {
            if (abi !== '' && number.test(abi) === false) { // Validazione codice società
                this.setState({
                    msgabi: ERRORMESSAGE.msgnumber,
                    abi: ''
                })
            } else if (abi !== '' && number.test(abi) === true) {
                this.setState({
                    msgabi: ''
                })
            }
        }
    }


    showResult() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const { history } = this.props;
        const self = this;

        if (this.state.selectedMonthYearLabel !== '') {
            this.setState({
                isRicerca: true
            })
            GetTotalSummaryCtrl(function (data) {
                self.setState({
                    dataHeader: data === '' ? {} : data,
                    pages: Math.ceil(data.count / 60)
                }, function() {
                    this.resultPage();
                });
            }, function (error) {
                if (error === 401 || error === 408) {
                    self.setState({
                        showTimeoutModal: true
                    })
                } else if (error === 500 || error === 404 || error === 403) {
                    history.push({
                        pathname: '/ErrorPage'
                    });
                }

            }, this.state, token, ids);
        }

    }

    resultPage(typeCall){
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const { history } = this.props;
        const self = this;

        this.setState({
            isRicerca: true,
            showDetailsTable: false
        })
        
        GetSummaryListCtrl(function (data) {
            self.setState({
                dataTable: data === '' ? [] : data,
                isRicerca: false,
                showresult: true
            });
        }, function (error) {
            if (error === 401 || error === 408) {
                self.setState({
                    showTimeoutModal: true
                })
            } else if (error === 500 || error === 404 || error === 403) {
                history.push({
                    pathname: '/ErrorPage'
                });
            }

        }, this.state, typeCall, token, ids);
    }


    downloadExcel(typeCall){
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const { history } = this.props;
        const self = this;
        this.setState({
            loadingExcel: true
          })

        this.setState({
            isRicerca: true,
            showDetailsTable: false
        })
        
        GetSummaryListCtrl(function (data) {
            self.setState({
                dataTable: data === '' ? [] : data,
                isRicerca: false,
                loadingExcel: false
            });
            document.getElementById('excel').click();
        }, function (error) {
            if (error === 401 || error === 408) {
                self.setState({
                    showTimeoutModal: true
                })
            } else if (error === 500 || error === 404 || error === 403) {
                history.push({
                    pathname: '/ErrorPage'
                });
            }

        }, this.state, typeCall, token, ids);
    }

    setPoint(i) {
        sessionStorage.setItem("i", i);
        if (sessionStorage.getItem("i", i)) {
            this.setState({
                value: parseInt(sessionStorage.getItem("i", i)),
                selected: parseInt(sessionStorage.getItem("i", i)),
                trBranchCode: this.state.dataTable[i].branchCode,
                trName: this.state.dataTable[i].name,
                trDate: this.state.dataTable[i].date,
                trUid: this.state.dataTable[i].uid,
                trNumber: this.state.dataTable[i].transactionNumber,
                trGross: this.state.dataTable[i].declaredGrossAmount,
                trCommission: this.state.dataTable[i].calculatedCommissionAmount,
                trNet: this.state.dataTable[i].calculatedNetAmount,
                trDeclaredNet: this.state.dataTable[i].declaredNetAmount
            });
        } else {
            this.setState({ value: null });
        }
    }

    showDetailsTable() {

        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const { history } = this.props;
        const self = this;
        var count = this.state.trNumber;

        GetSummaryTransactionListCtrl(function (data) {
            self.setState({
                dataTableDetails: data === '' ? [] : data,
                pages:  Math.ceil(count / 60)
            }, function() {
                self.setState({
                    showDetailsTable: true
                })
            });
        }, function (error) {
            if (error === 401 || error === 408) {
                self.setState({
                    showTimeoutModal: true,
                    showDetailsTable: false
                })
            } else if (error === 500 || error === 404 || error === 403) {
                history.push({
                    pathname: '/ErrorPage'
                });
            }

        }, this.state, token, ids);

        // this.setState({
        //     showDetailsTable: true
        // })
    }

    hideDetails() {
        this.setState({
            showDetailsTable: false
        })
    }

    search(){
        this.setState({
            currentPage: 1,
            pages: 0,
            dataHeader: {},
            dataTable: [],
            selected: "",
            trBranchCode: "",
            showresult: false
        }, () => {
            this.showResult();
        });
    }
    
    prevPage(param){
        let cp = this.state.currentPage;
        if (cp === 1) return;
        this.setState({
          currentPage: cp - 1
        },() => {
            if(param === "R") {
                this.resultPage();
            } else {
                this.showDetailsTable();
            }
        });
    }
    
    nextPage(param){
        let cp = this.state.currentPage;
        if (cp === this.state.pages) return;
        this.setState({
            currentPage: cp + 1
        },() => {
            if(param === "R") {
                this.resultPage();
            } else {
                this.showDetailsTable();
            }
        });
    }

    goToPage(param, page) {
        if(page === this.state.currentPage) return;
        this.setState({
            currentPage: page
        },() => {
            if(param === "R") {
                this.resultPage();
            } else {
                this.showDetailsTable();
            }
        });
    }

    openModal() {
        this.setState({
            showModalError: true
        })
    }

    closeModal() {
        this.setState({
            showModalError: false
        })
    }

    render() {

        const columns = [
            {
                Header: "",
                accessor: "",
                width: 40,
                Cell: row => (
                    <div>
                        <RadioButton
                            id={"radio" + [row.index]}
                            className="radiobutton"
                            checked={this.state.selected === row.index ? true : false}
                            onChange={this.setPoint.bind(this, row.index)}
                            value={row.index}
                        />
                    </div>
                ),
                maxWidth: 60
            },
            {
                Header: 'CODICE ESERCIZIO',
                accessor: 'branchCode',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'INSEGNA',
                accessor: 'name',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DATA',
                accessor: 'date',
                width: 65,
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'ABI',
                accessor: 'bank',
                width: 55,
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DESCRIZIONE OPERAZIONE',
                accessor: 'code',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'RIFERIMENTO',
                accessor: 'uid',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'NUMERO TRANSAZIONI',
                accessor: 'transactionNumber',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'LORDO CALCOLATO',
                accessor: 'calculatedGrossAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'LORDO DICHIARATO',
                accessor: 'declaredGrossAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'COMMISSIONI CALCOLATE',
                accessor: 'calculatedCommissionAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'NETTO CALCOLATO',
                accessor: 'calculatedNetAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'NETTO DICHIARATO',
                accessor: 'declaredNetAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            }
        ]

        const columnsDetails = [
            {
                Header: 'CODICE ESERCIZIO',
                accessor: 'branchCode',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'INSEGNA',
                accessor: 'name',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DATA',
                accessor: 'date',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'RIFERIMENTO',
                accessor: 'summary',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'POS',
                accessor: 'pos',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'LORDO',
                accessor: 'amount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'CODICE AUTORIZZAZIONE',
                accessor: 'autorization',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'LORDO CALCOLATO',
                accessor: 'calculatedGrossAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => row.value !== undefined ? formatAmount(row.value) : null
            },
            {
                Header: 'LORDO DICHIARATO',
                accessor: 'calculatedGrossAmount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => row.value !== undefined ? formatAmount(row.value) : null
            },
            {
                Header: 'NUMERO CARTA',
                accessor: 'pan',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'STATO',
                accessor: 'status',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'COMMISSIONI',
                accessor: 'commission',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'NETTO',
                accessor: 'net',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },

        ]
        
        const resultHeader = ( <Box>
                                <Box style={{ width: '100%', padding: '50px 24px 0', textAlign: 'left' }}>
                                    <Text className='searchResult'>RISULTATI DI RICERCA</Text>
                                </Box>
                                <Box>
                                    <Box className='containerMenu' id='riepilogo' direction='row'>
                                        <Box className='floatTextLeft' direction='row'>
                                            <Box className='overTC'>
                                                <Box className='tdBold'>
                                                    Cod Societario:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Punto Vendita:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Insegna:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Periodo:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Nr. Riepiloghi:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Totale Lordo Calcolato:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Totale Commissioni Calcolato:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Totale Netto Calcolato:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Totale Netto Dichiarato:
                                                </Box>
                                                <Box className='tdBold'>
                                                    Totale Differenza:
                                                </Box>
                                            </Box>
                                            <Box className='overTCExt'>
                                                <Box className='tdBold'>
                                                    {sessionStorage.getItem("codesoc")}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {sessionStorage.getItem('code') ? sessionStorage.getItem('code') : "Tutti"}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {sessionStorage.getItem("insegna")}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {this.state.selectedMonthYearLabel}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {this.state.dataHeader.count}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {formatAmount(this.state.dataHeader.amount)}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {formatAmount(this.state.dataHeader.commission)}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {formatAmount(this.state.dataHeader.net)}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {formatAmount(this.state.dataHeader.declared)}
                                                </Box>
                                                <Box className='tdBold'>
                                                    {formatAmount(this.state.dataHeader.difference)}
                                                </Box>
                                            </Box>
                                        </Box>

                                    </Box>
                                </Box>
                            </Box>)

        const resultTable = ([<Box>
                                <Box direction='row' style={{ padding: '0px 2%' }}>
                                    <Box pad='large' style={{ 'overflow-x': 'auto', width: '100%', padding: '0' }}>
                                        <div role="region" aria-label="Tabella riepilogo" tabIndex="0">
                                            <ReactTable
                                                data={this.state.dataTable}
                                                columns={columns}
                                                sortable={true}
                                                multiSort={false}
                                                resizable={true}
                                                showPagination={false}
                                                loading={this.state.loading}
                                                defaultPageSize={this.state.dataTable.length}
                                                style={{ paddingBottom: '20px' }}
                                                getTheadThProps={() => ({
                                                    role: 'columnheader',
                                                    tabIndex: 0,
                                                    'aria-sort': 'none',
                                                    onKeyDown: (e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            e.target.click();
                                                        }
                                                    }
                                                })}
                                                getTdProps={() => ({
                                                    tabIndex: 0,
                                                    role: 'cell',
                                                    onKeyDown: (e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            e.target.click();
                                                        }
                                                    }
                                                })}
                                                getTrProps={() => ({
                                                    role: 'row',
                                                    tabIndex: -1
                                                })}
                                                getTheadGroupProps={() => ({
                                                    role: 'rowgroup'
                                                })}
                                                getTbodyProps={() => ({
                                                    role: 'rowgroup'
                                                })}
                                            />
                                        </div>
                                        <div>
                                            <div style={{ height: '50px', display: 'flex-wrap', flexDirection: 'row' }}>
                                                <button
                                                    type="button"
                                                    onClick={() => this.goToPage("R", 1)}
                                                    onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && this.goToPage("R", 1)}
                                                    aria-label="Prima pagina riepilogo"
                                                    disabled={this.state.currentPage === 1}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: this.state.currentPage === 1 ? '#999' : '#006fcf',
                                                        cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer',
                                                        padding: '5px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        outline: 'none',
                                                        width: '20px',
                                                        height: '30px'
                                                    }}
                                                >
                                                    <i className='icon-double-left' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true" />
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => this.prevPage("R")}
                                                    onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && this.prevPage("R")}
                                                    aria-label="Pagina precedente"
                                                    disabled={this.state.currentPage === 1}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: this.state.currentPage === 1 ? '#999' : '#006fcf',
                                                        cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer',
                                                        padding: '5px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        outline: 'none',
                                                        width: '20px',
                                                        height: '30px'
                                                    }}
                                                >
                                                    <i className='icon-left-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true" />
                                                </button>

                                                <Text className='pag' style={{ fontSize: '12px', marginBottom: '12px' }}>{this.state.currentPage} di {this.state.pages}</Text>

                                                <button
                                                    type="button"
                                                    onClick={() => this.nextPage("R")}
                                                    onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && this.nextPage("R")}
                                                    aria-label="Pagina successiva"
                                                    disabled={this.state.currentPage === this.state.pages}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf',
                                                        cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer',
                                                        padding: '5px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        outline: 'none',
                                                        width: '20px'
                                                    }}
                                                >
                                                    <i className='icon-right-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true" />
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => this.goToPage("R", this.state.pages)}
                                                    onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && this.goToPage("R", this.state.pages)}
                                                    aria-label="Ultima pagina"
                                                    disabled={this.state.currentPage === this.state.pages}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf',
                                                        cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer',
                                                        padding: '5px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        outline: 'none',
                                                        width: '20px'
                                                    }}
                                                >
                                                    <i className='icon-double-right' style={{ fontSize: '12px', fontStyle: 'normal' }} aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                    </Box>
                                </Box>
                                {this.state.loadingExcel ? 

                                    <Box>   
                                        {loader}
                                    </Box>

                                    :
                                <Box className='contentXsls'>
                                    <button 
                                        onClick={() => this.downloadExcel("C")}
                                        onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && this.downloadExcel("C")}
                                        className='excel'
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: '8px 16px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            outline: 'none',
                                            width: '100%',
                                            textAlign: 'left'
                                        }}
                                        aria-label="Esporta in formato Excel"
                                    >
                                        <span className='export'>
                                            ESPORTA
                                            <i 
                                                className='icon-xlsx-file-format-extension' 
                                                style={{ 
                                                    fontSize: '20px', 
                                                    marginLeft: '10px', 
                                                    verticalAlign: 'middle' 
                                                }}
                                                aria-hidden="true"
                                            />
                                        </span>
                                    </button>
                                   
                                    <ExcelFile filename='Riepilogo' id='span' element={<span style={{margin:'0'}} id='excel'/>}>
                                        <ExcelSheet data={this.state.dataTable} name="Riepilogo">
                                            <ExcelColumn label="CODICE ESERCIZIO" value="branchCode" />
                                            <ExcelColumn label="INSEGNA" value="name" />
                                            <ExcelColumn label="DATA" value="date" />
                                            <ExcelColumn label="ABI" value='bank' />
                                            <ExcelColumn label="DESCRIZIONE OPERAZIONE" value="code" />
                                            <ExcelColumn label="RIFERIMENTO" value="uid" />
                                            <ExcelColumn label="NUMERO TRANSAZIONI" value="transactionNumber" />
                                            <ExcelColumn label="LORDO CALCOLATO" value="calculatedGrossAmount" />
                                            <ExcelColumn label="LORDO DICHIARATO" value="declaredGrossAmount" />
                                            <ExcelColumn label="COMMISSIONI CALCOLATE" value="calculatedCommissionAmount" />
                                            <ExcelColumn label="NETTO CALCOLATO" value="calculatedNetAmount" />
                                            <ExcelColumn label="NETTO DICHIARATO" value="declaredNetAmount" />
                                        </ExcelSheet>
                                    </ExcelFile>

                                    <Box className='visualizzaBtn'>
                                        <Button className='btnsearchForm btnDet' onClick={this.state.trBranchCode === "" ? this.openModal : this.showDetailsTable} aria-label="Visualizza dettagli completo del riepilogo selezionato">
                                            Visualizza Dettaglio
                                        </Button>
                                    </Box>
                                </Box>}
                            </Box>])

        const resultDetails = (<Layer
                                flush={true}
                                margin='medium'
                                onClickOutside={this.props.closeModal}
                                onEsc={this.props.closeModal}>
                                    <Box overflow='auto'>
                                        <Box style={{ width: '100%', textAlign: 'left', padding: "35px 30px 0", minHeight:'auto'}}>
                                            <Text className='searchResult'>DETTAGLIO TABELLA
                                                <button
  onClick={this.hideDetails}
  aria-label="Chiudi dettagli"
  style={{
    textAlign: 'right', fontSize: '15px', color: '#000000', float: 'right', cursor: 'pointer', background: 'none', border: 'none', padding: 0
  }}
>
  <i className='icon-close' aria-hidden="true"></i>
  <span className="sr-only">Chiudi dettagli</span>
</button>
                                            </Text>
                                        </Box>
                                        <Box style={{padding: "0 30px", minHeight: 'auto'}}>
                                            <Box className='containerMenu' id='details' style={{ padding: '24px 0 !important' }} direction='row'>
                                                <Box className='floatTextLeft' direction='row'>
                                                    <Box className='overTC'>
                                                        <Box className='tdBold'>
                                                            Cod Societario:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Punto Vendita:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Insegna:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Data:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Nr. Riepilogo:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Nr. Transazioni:
                                                        </Box>
                                                    </Box>
                                                    <Box className='overTC'>
                                                        <Box className='tdBold'>
                                                            {sessionStorage.getItem("codesoc")}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {this.state.trBranchCode}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {this.state.trName}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {this.state.trDate}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {this.state.trUid}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {this.state.trNumber}
                                                        </Box>
                                                    </Box>
                                                </Box>


                                                <Box className='floatTextRight' direction='row'>
                                                    <Box className='overTC'>
                                                        <Box className='tdBold'>
                                                            Totale Lordo Calcolato:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Totale Commissioni Calcolato:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Totale Netto Calcolato:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Totale Netto Dichiarato:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            Totale Differenza:
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            &nbsp;
                                                        </Box>
                                                    </Box>
                                                    <Box className='overTC'>
                                                        <Box className='tdBold'>
                                                            {formatAmount(this.state.trGross)}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {formatAmount(this.state.trCommission)}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {formatAmount(this.state.trNet)}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            {formatAmount(this.state.trDeclaredNet)}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            - {formatAmount(this.state.trCommission)}
                                                        </Box>
                                                        <Box className='tdBold'>
                                                            &nbsp;
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>

                                            <Box direction='row'>
                                                <Box pad='large' style={{ 'overflow-x': 'auto', width: '100%', padding: '0' }}>
                                                    <ReactTable
                                                        data={this.state.dataTableDetails}
                                                        columns={columnsDetails}
                                                        sortable={true}
                                                        multiSort={true}
                                                        resizable={true}
                                                        showPagination={false}
                                                        loading={false}
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box className='contentXsls' style={{ padding: '10px 6px', minHeight: 'auto' }}>
                                            <ExcelFile filename='Pratiche' element={<Box direction='row'><Text className='export'>ESPORTA<i className='icon-xlsx-file-format-extension' style={{ fontSize: '20px', marginLeft: '10px', verticalAlign: 'middle' }}></i></Text></Box>}>
                                                <ExcelSheet data={this.state.dataTableDetails} name="Riepilogo Dettaglio">
                                                    <ExcelColumn label="CODICE ESERCIZIO" value="branchCode" />
                                                    <ExcelColumn label="INSEGNA" value="name" />
                                                    <ExcelColumn label="DATA" value="date" />
                                                    <ExcelColumn label="RIFERIMENTO" value='summary' />
                                                    <ExcelColumn label="POS" value="pos" />
                                                    <ExcelColumn label="LORDO" value="amount" />
                                                    <ExcelColumn label="CODICE AUTORIZZAZIONE" value="autorization" />
                                                    <ExcelColumn label="LORDO CALCOLATO" value="calculatedGrossAmount" />
                                                    <ExcelColumn label="LORDO DICHIARATO" value="calculatedGrossAmount" />
                                                    <ExcelColumn label="NUMERO CARTA" value="pan" />
                                                    <ExcelColumn label="STATO" value="status" />
                                                    <ExcelColumn label="COMMISSIONI" value="commission" />
                                                    <ExcelColumn label="NETTO" value="net" />
                                                </ExcelSheet>
                                            </ExcelFile>
                                        </Box>
                                    </Box>
                                </Layer>
                            )
        
        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                {this.state.showModalError ? <ModalError type="details" closeModal={this.closeModal}/> : ''}
                <Box align='center' className='content riepilogo-page' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                    <Box className='contentbox'>
                        <Box pad='medium' align='start' style={{ paddingBottom: '50px' }}>
                            <Text className='titlehome'><h1>Consulta Riepilogo</h1></Text>
                            <Text className='subtitlehome'><h3>Seleziona i filtri di ricerca</h3></Text>
                        </Box>
                        <Box align='center' id='searchpv' justify='center' >
                            <Text className='titlesectionhome'><h3>PERIODO TEMPORALE</h3></Text>
                            <Box className='genericext rowColumnRiepilogo' direction='row' gap='medium'>
                                <Box style={{ flex: '0 0 200px' }}>
                                    <Text className='label' htmlFor='month' id='month-label' aria-hidden="false"><h5>MESE E ANNO*</h5></Text>
                                    <AccessibleSelect 
                                        id='month' 
                                        className='select' 
                                        placeholder='Seleziona Mese' 
                                        options={this.state.months.map(month => ({
                                            label: month,
                                            value: month,
                                            'aria-label': month
                                        }))}
                                        labelKey='label'
                                        valueKey='value'
                                        value={this.state.selectedMonthYearLabel ? {
                                            label: this.state.selectedMonthYearLabel,
                                            value: this.state.selectedMonthYearLabel,
                                            'aria-label': this.state.selectedMonthYearLabel
                                        } : ''} 
                                        onChange={this.setSelectionYearMonth}
                                        aria-labelledby='month-label periodo-temporale-section'
                                        aria-required='true'
                                        a11yTitle='Mese e anno'
                                        dropAlign={{ top: 'bottom' }}
                                        dropProps={{
                                            a11yTitle: 'Opzioni di mese e anno disponibili',
                                            role: 'listbox',
                                            'aria-multiselectable': 'false'
                                        }}
                                        messages={{
                                            multiple: 'Selezionato',
                                            selected: 'Selezionato'
                                        }}
                                    />
                                </Box>
                                <Box style={{ flex: '0 0 200px' }}>
                                    <Text className='label' htmlFor='day' id='day-label' aria-hidden="false"><h5>GIORNO</h5></Text>
                                    <AccessibleSelect 
                                        id='day' 
                                        className='select' 
                                        placeholder='Seleziona Giorno' 
                                        disabled={this.state.disabledSDays} 
                                        options={this.state.optionsDay.filter(day => day !== "").map(day => ({
                                            label: day,
                                            value: day,
                                            'aria-label': day
                                        }))}
                                        labelKey='label'
                                        valueKey='value'
                                        value={this.state.selectedDay ? {
                                            label: this.state.selectedDay,
                                            value: this.state.selectedDay,
                                            'aria-label': this.state.selectedDay
                                        } : ''}
                                        onChange={this.setSelectionDay}
                                        aria-labelledby='day-label periodo-temporale-section'
                                        a11yTitle='Giorno'
                                        dropAlign={{ top: 'bottom' }}
                                        dropProps={{
                                            a11yTitle: 'Opzioni di giorno disponibili',
                                            role: 'listbox',
                                            'aria-multiselectable': 'false'
                                        }}
                                        messages={{
                                            multiple: 'Selezionato',
                                            selected: 'Selezionato'
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <Text className='label' htmlFor='abi' id='abi-label'><h5>ABI</h5></Text>
                                    <TextInput 
                                        id='abi' 
                                        maxLength={5} 
                                        className='inputSearchpv' 
                                        value={this.state.abi} 
                                        placeholder='' 
                                        onChange={this.setAmount} 
                                        onBlur={this.validForm}
                                        aria-labelledby='abi-label periodo-temporale-section'
                                    />
                                    {this.state.msgabi ? <Text className='error'>{this.state.msgabi}</Text> : <Text className='errorhide'></Text>}
                                </Box>
                            </Box>
                            <Text className='titlesectionhome' id='lordo-calcolato-section'><h3>LORDO CALCOLATO</h3></Text>
                            <Box className='genericextRiep' direction='row' gap='medium'>
                                <Box>
                                    <Text className='label' htmlFor='minamount' id='minamount-label'><h5>MIN</h5></Text>
                                    <TextInput 
                                        id='minamount' 
                                        className='inputSearchpv' 
                                        maxLength={13} 
                                        value={this.state.minamount} 
                                        placeholder='' 
                                        onChange={this.setAmount}
                                        aria-labelledby='minamount-label lordo-calcolato-section'
                                        aria-describedby='minamount-currency'
                                    />
                                    <Text className='span' id='minamount-currency' aria-hidden='true'>,00</Text>
                                </Box>
                                <Box className='marginLeft'>
                                    <Text className='label' htmlFor='maxamount' id='maxamount-label'><h5>MAX</h5></Text>
                                    <TextInput 
                                        id='maxamount' 
                                        className='inputSearchpv' 
                                        maxLength={13} 
                                        value={this.state.maxamount} 
                                        placeholder='' 
                                        onChange={this.setAmount}
                                        aria-labelledby='maxamount-label lordo-calcolato-section'
                                        aria-describedby='maxamount-currency'
                                    />
                                    <Text className='span' id='maxamount-currency' aria-hidden='true'>,00</Text>
                                </Box>
                            </Box>

                            <Text className='titlesectionhome' id='lordo-dichiarato-section'><h3>LORDO DICHIARATO</h3></Text>
                            <Box className='genericextRiep' direction='row' gap='medium'>
                                <Box>
                                    <Text className='label' htmlFor='minamountnet' id='minamountnet-label'><h5>MIN</h5></Text>
                                    <TextInput 
                                        id='minamountnet' 
                                        className='inputSearchpv' 
                                        maxLength={13} 
                                        value={this.state.minamountnet} 
                                        placeholder='' 
                                        onChange={this.setAmount}
                                        aria-labelledby='minamountnet-label lordo-dichiarato-section'
                                        aria-describedby='minamountnet-currency'
                                    />
                                    <Text className='span' id='minamountnet-currency' aria-hidden='true'>,00</Text>
                                </Box>
                                <Box className='marginLeft'>
                                    <Text className='label' htmlFor='maxamountnet' id='maxamountnet-label'><h5>MAX</h5></Text>
                                    <TextInput 
                                        id='maxamountnet' 
                                        className='inputSearchpv' 
                                        maxLength={13} 
                                        value={this.state.maxamountnet} 
                                        placeholder='' 
                                        onChange={this.setAmount}
                                        aria-labelledby='maxamountnet-label lordo-dichiarato-section'
                                        aria-describedby='maxamountnet-currency'
                                    />
                                    <Text className='span' id='maxamountnet-currency' aria-hidden='true'>,00</Text>
                                </Box>
                            </Box>

                            <Box className='genericextRiep'>
                                <Text className='suggestion'><h5>*Campi obbligatori</h5></Text>
                            </Box>
                            <Box style={{ marginTop: '30px' }}>
                                <Button 
                                    className={!this.state.selectedYearMonth ? 'btnsearchForm disabled' : 'btnsearchForm'} 
                                    onClick={this.search} 
                                    disabled={!this.state.selectedMonthYearLabel}
                                    aria-label="Cerca riepiloghi con i filtri selezionati"
                                    role="button"
                                >
                                    <i className='icon-magnifying-glass' style={{ fontSize: '20px', fontStyle: 'normal' }} aria-hidden="true"> CERCA</i>
                                </Button>
                            </Box>

                        </Box>
                        
                        {this.state.showresult ? 
                            <Box>
                                {resultHeader}
                                {resultTable}
                            </Box>
                            : this.state.isRicerca ?
                                loader
                            : null
                        }

                        {this.state.showDetailsTable ?
                            resultDetails
                            : null}

                        

                    </Box>

                </Box>

            </Box>
        )
    }
}
export default Riepilogo;
